// extracted by mini-css-extract-plugin
module.exports = {"brown":"TagLabel__brown","grey":"TagLabel__grey","withoutBorder":"TagLabel__withoutBorder","hasLink":"TagLabel__hasLink"};